import { InjectionToken } from '@angular/core';
import { UserSettingsRoutes } from '../models/user-settings-routes';

export const USER_SETTINGS_ROUTES = new InjectionToken<UserSettingsRoutes>('User Settings Route');
